// @ts-nocheck

import { ErrorProvider } from '../../../libraries/branch-tooling-next/Error/ErrorProvider';
import dash_api from '../../main/support/dash_api';
import { ReduxAsyncAction } from '../support/utils';
import type {
  CappingConfigUpdateData,
  FraudAgentUpdatePart,
  FraudRuleSubpart,
  NewFraudAgent,
  NewFraudRule,
} from '../types/fraudTypes';
import NotificationActions from './NotificationActions';
const FRAUD_RULE_PATH = '/v1/fraud-rules';
const CAPPING_CONFIGURATION_PATH = '/v1/capping-configuration';
const FRAUD_AGENTS_PATH = '/v1/fraud-agents';
const FRAUD_AGENTS_METRICS_PATH = '/v1/fraud-agents-metrics';
const errorProvider = new ErrorProvider();
const GetFraudRules = new ReduxAsyncAction('GET_FRAUD_RULES');
GetFraudRules.registerRequest(function () {
  return dash_api.get(FRAUD_RULE_PATH).then(({ data }) => data);
});
export const GET_FRAUD_RULES = GetFraudRules.constants;
export const getFraudRules = GetFraudRules.request;
const UpdateFraudRule = new ReduxAsyncAction('UPDATE_FRAUD_RULE');
UpdateFraudRule.registerRequest(function (fraudRulePart: FraudRuleSubpart) {
  return dash_api
    .put(FRAUD_RULE_PATH, {
      fraudRulePart,
    })
    .then(({ data }) => data);
});
export const UPDATE_FRAUD_RULE = UpdateFraudRule.constants;
export const updateFraudRule =
  (fraudRulePart: FraudRuleSubpart) => async (dispatch: (action: Record<string, any>) => Record<string, any>) => {
    try {
      await dispatch(UpdateFraudRule.request(fraudRulePart));
    } catch (err) {
      err.data && NotificationActions.showNotification(errorProvider.parse(err).getMessageOrEmpty(), 'error');
    }
  };
const CreateFraudRule = new ReduxAsyncAction('CREATE_FRAUD_RULE');
CreateFraudRule.registerRequest(function (newFraudRule: NewFraudRule) {
  return dash_api
    .post(FRAUD_RULE_PATH, {
      newFraudRule,
    })
    .then(({ data }) => data);
});
export const CREATE_FRAUD_RULE = CreateFraudRule.constants;
export const createFraudRule =
  (newFraudRule: NewFraudRule) => async (dispatch: (action: Record<string, any>) => Record<string, any>) => {
    try {
      await dispatch(CreateFraudRule.request(newFraudRule));
    } catch (err) {
      err.data && NotificationActions.showNotification(errorProvider.parse(err).getMessageOrEmpty(), 'error');
    }
  };
// To keep all fraud rule for druid data name mapping, we choose to
// only archive fraud rules from the dashboard.
const ArchiveFraudRule = new ReduxAsyncAction('ARCHIVE_FRAUD_RULE');
ArchiveFraudRule.registerRequest(function (id: string) {
  const fraudRulePart = {
    id,
    status: 'ARCHIVED',
  };
  return dash_api
    .put(FRAUD_RULE_PATH, {
      fraudRulePart,
    })
    .then(({ data }) => data);
});
export const ARCHIVE_FRAUD_RULE = ArchiveFraudRule.constants;
export const archiveFraudRule = ArchiveFraudRule.request;
const GetCappingConfiguration = new ReduxAsyncAction('GET_CAPPING_CONFIGURATION');
GetCappingConfiguration.registerRequest(function () {
  return dash_api.get(CAPPING_CONFIGURATION_PATH).then(({ data }) => data);
});
export const GET_CAPPING_CONFIGURATION = GetCappingConfiguration.constants;
export const getCappingConfiguration = GetCappingConfiguration.request;
const UpdateCappingConfiguration = new ReduxAsyncAction('UPDATE_CAPPING_CONFIGURATION');
UpdateCappingConfiguration.registerRequest(function (cappingConfigUpdateData: CappingConfigUpdateData) {
  return dash_api
    .put(CAPPING_CONFIGURATION_PATH, {
      cappingConfigUpdateData,
    })
    .then(({ data }) => data);
});
export const UPDATE_CAPPING_CONFIGURATION = UpdateCappingConfiguration.constants;
export const updateCappingConfiguration =
  (cappingConfigUpdateData: CappingConfigUpdateData) =>
  async (dispatch: (action: Record<string, any>) => Record<string, any>) => {
    try {
      await dispatch(UpdateCappingConfiguration.request(cappingConfigUpdateData));
    } catch (err) {
      err.data && NotificationActions.showNotification(errorProvider.parse(err).getMessageOrEmpty(), 'error');
    }
  };
const CreateOnceEverCap = new ReduxAsyncAction('CREATE_ONCE_EVER_CAP');
CreateOnceEverCap.registerRequest(function (cappingEventName: string) {
  return dash_api
    .post(CAPPING_CONFIGURATION_PATH, {
      cappingEventName,
    })
    .then(({ data }) => data);
});
export const CREATE_ONCE_EVER_CAP = CreateOnceEverCap.constants;
export const createOnceEverCap =
  (cappingEventName: string) => async (dispatch: (action: Record<string, any>) => Record<string, any>) => {
    try {
      await dispatch(CreateOnceEverCap.request(cappingEventName));
    } catch (err) {
      err.data && NotificationActions.showNotification(errorProvider.parse(err).getMessageOrEmpty(), 'error');
    }
  };
export const REMOVE_ONCE_EVER_CAP = 'REMOVE_ONCE_EVER_CAP';
export const removeOnceEverCap = (cappingEventName: string) => ({
  type: 'REMOVE_ONCE_EVER_CAP',
  data: {
    cappingEventName,
  },
});
const DeleteOnceEverCap = new ReduxAsyncAction('DELETE_ONCE_EVER_CAP');
DeleteOnceEverCap.registerRequest(function (cappingEventName: string) {
  return dash_api.delete(`${CAPPING_CONFIGURATION_PATH}/${cappingEventName}`);
});
export const DELETE_ONCE_EVER_CAP = DeleteOnceEverCap.constants;
export const deleteOnceEverCap =
  (cappingEventName: string) => async (dispatch: (action: Record<string, any>) => Record<string, any>) => {
    try {
      await dispatch(DeleteOnceEverCap.request(cappingEventName));
      await dispatch(removeOnceEverCap(cappingEventName));
    } catch (err) {
      err.data && NotificationActions.showNotification(errorProvider.parse(err).getMessageOrEmpty(), 'error');
    }
  };
const GetFraudAgentTemplates = new ReduxAsyncAction('GET_FRAUD_AGENT_TEMPLATES');
GetFraudAgentTemplates.registerRequest(function () {
  return dash_api.get(`${FRAUD_AGENTS_PATH}/templates`).then(({ data }) => data);
});
export const GET_FRAUD_AGENT_TEMPLATES = GetFraudAgentTemplates.constants;
export const getFraudAgentTemplates = GetFraudAgentTemplates.request;
const GetFraudAgents = new ReduxAsyncAction('GET_FRAUD_AGENTS');
GetFraudAgents.registerRequest(function () {
  return dash_api.get(FRAUD_AGENTS_PATH).then(({ data }) => data);
});
export const GET_FRAUD_AGENTS = GetFraudAgents.constants;
export const getFraudAgents = GetFraudAgents.request;
const UpdateFraudAgent = new ReduxAsyncAction('UPDATE_FRAUD_AGENT');
UpdateFraudAgent.registerRequest(function (fraudAgentUpdatePart: FraudAgentUpdatePart) {
  return dash_api
    .put(FRAUD_AGENTS_PATH, {
      fraudAgentUpdatePart,
    })
    .then(({ data }) => data);
});
export const UPDATE_FRAUD_AGENT = UpdateFraudAgent.constants;
export const updateFraudAgent = UpdateFraudAgent.request;
const CreateFraudAgent = new ReduxAsyncAction('CREATE_FRAUD_AGENT');
CreateFraudAgent.registerRequest(function (newFraudAgent: NewFraudAgent) {
  return dash_api
    .post(FRAUD_AGENTS_PATH, {
      newFraudAgent,
    })
    .then(({ data }) => data);
});
export const CREATE_FRAUD_AGENT = CreateFraudAgent.constants;
export const createFraudAgent = CreateFraudAgent.request;
// To keep all fraud rule for druid data name mapping, we choose to
// only archive fraud rules from the dashboard.
const ArchiveFraudAgent = new ReduxAsyncAction('ARCHIVE_FRAUD_AGENT');
ArchiveFraudAgent.registerRequest(function (agentId: string) {
  const fraudAgentUpdatePart = {
    agent_id: agentId,
    agent_status: 'ARCHIVED',
  };
  return dash_api
    .put(FRAUD_AGENTS_PATH, {
      fraudAgentUpdatePart,
    })
    .then(({ data }) => data);
});
export const ARCHIVE_FRAUD_AGENT = ArchiveFraudAgent.constants;
export const archiveFraudAgent = ArchiveFraudAgent.request;
const GetFraudAgentsMetrics = new ReduxAsyncAction('GET_FRAUD_AGENTS_METRICS');
GetFraudAgentsMetrics.registerRequest(function () {
  return dash_api.get(FRAUD_AGENTS_METRICS_PATH).then(({ data }) => data);
});
export const GET_FRAUD_AGENTS_METRICS = GetFraudAgentsMetrics.constants;
export const getFraudAgentsMetrics = GetFraudAgentsMetrics.request;
